// import { SET_TAGS_LIST } from '../mutation-types'
// import { otherRouter } from '@/router'

// 该模块的初始状态
const state = {
  visitedViews: [],
  cachedViews: [],
  mapping: {}
}

// 相关的 mutations
const mutations = {
  UPDATE_MAPPING: (state, view) => {
    state.mapping[view.name] = view.meta.tag
  },
  ADD_VISITED_VIEW: (state, view) => {
    let has = state.visitedViews.some((item) => {
      return item.path === view.path
    })
    if (has) return
    state.visitedViews.push(view)
  },
  DEL_VISITED_VIEW: (state, view) => {
    state.visitedViews = state.visitedViews.filter((item) => {
      return item.path !== view.path
    })
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    // if (!view.meta.noCache) {
    state.cachedViews.push(view.name)
    // }
  },
  DEL_CACHED_VIEW: (state, view) => {
    for (const i of state.cachedViews) {
      if (i === view.name) {
        const index = state.cachedViews.indexOf(i)
        state.cachedViews.splice(index, 1)
        break
      }
    }
  },
  CLEAN: (state) => {
    state.visitedViews = []
    state.cachedViews = []
    state.mapping = {}
  }
}

const actions = {
  updateMapping: ({ commit }, view) => {
    commit('UPDATE_MAPPING', view)
  },
  addVisitedView: ({ commit }, view) => {
    commit('ADD_VISITED_VIEW', view)
  },
  delVisitedView: ({ commit }, view) => {
    commit('DEL_VISITED_VIEW', view)
  },
  addCachedView ({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },
  delCachedView ({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },
  addView ({ dispatch }, view) {
    dispatch('addVisitedView', view)
    dispatch('addCachedView', view)
    dispatch('updateMapping', view)
  },
  delView ({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  cleanViews ({ commit }) {
    commit('CLEAN')
  }
}

const getters = {
  visitedViews: state => {
    return state.visitedViews
  },
  cachedViews: state => {
    return state.cachedViews
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
